// import { DEFAULT_CURRENCY_FORMAT } from '@eventbrite/legacy-infra.intl/constants';
import { AnyAction, combineReducers } from 'redux';
import { thingsToDoShelfReducer } from '../thingsToDoShelf';
import { appReducer } from '../app';
// import { contentReducer } from '../content';
// import { headerReducer } from '../header';
import { locationReducer } from '../location';
// import { organizersReducer } from '../organizers';
// import { searchReducer, suggestionsReducer } from '../search';
// import { userReducer } from '../user';
import { UPDATE_ROOT_CONTEXT } from './rootActionTypes';
import { HYDRATE } from 'next-redux-wrapper';

export const _rootReducer = combineReducers({
    app: appReducer,
    //    content: contentReducer,
    location: locationReducer,
    // suggestions: suggestionsReducer,
    //    user: userReducer,
    thingsToDoShelf: thingsToDoShelfReducer,
    //    organizers: organizersReducer,
    // search: searchReducer,
    env: (state = {}) => state,
    // currencyFormat: (state = DEFAULT_CURRENCY_FORMAT) => state,
    // shareOptions: (state = {}) => state,
    // header: headerReducer,
    // headerImageIndex: (state = '') => state,
});

export function rootReducer(state = {}, action: AnyAction): ReturnType<typeof _rootReducer> {
    let newState = state;

    if (action?.type === HYDRATE) {
        return { ...state, ...action.payload };
    }

    if (action && action.type === UPDATE_ROOT_CONTEXT) {
        newState = action.payload;
    }

    return _rootReducer(newState, action);
}
